import React from 'react';

export default function TopFilterBar({
  plants = [],
  selectedPlant,
  onPlantChange,
  meters = [],
  selectedMeter,
  onMeterChange,
  unit,
  onUnitChange,
  hasMeterPhoto = false,
  onMeterPhotoClick,
}) {
  return (
    <div className="filters">
      <div className="field">
        <label>Select plant</label>
        <div className="sel">
          <select
            value={selectedPlant || ''}
            onChange={(e) => onPlantChange(e.target.value)}
          >
            {plants.length > 0 ? (
              plants.map((p) => (
                <option key={p.value} value={p.value}>
                  {p.label}
                </option>
              ))
            ) : (
              <option value="">Select Plant</option>
            )}
          </select>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 9l6 6 6-6" />
          </svg>
        </div>
      </div>

      <div className="field">
        <label>Select meter</label>
        <div className="sel">
          <select
            value={selectedMeter}
            onChange={(e) => onMeterChange(e.target.value)}
          >
            {meters.map((m) => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </select>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 9l6 6 6-6" />
          </svg>
        </div>
      </div>

      <div className="spacer"></div>

      <div className="field">
        <label>Units</label>
        <div className="seg unit-seg">
          <button
            className={unit === 'KL' ? 'on' : ''}
            onClick={() => onUnitChange('KL')}
          >
            KL
          </button>
          <button
            className={unit === 'm³' ? 'on' : ''}
            onClick={() => onUnitChange('m³')}
          >
            m³
          </button>
        </div>
      </div>

      <button
        type="button"
        className="btn ghost"
        onClick={onMeterPhotoClick}
        title={hasMeterPhoto ? 'Meter photo is uploaded (Click to view/change)' : 'No meter photo uploaded (Click to upload)'}
        style={
          hasMeterPhoto
            ? {
                borderColor: '#86efac',
                background: '#f0fdf4',
                color: '#15803d',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '7px',
                fontWeight: 650,
              }
            : {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '7px',
              }
        }
      >
        <svg viewBox="0 0 24 24" fill="none" stroke={hasMeterPhoto ? '#16a34a' : 'currentColor'} strokeWidth="2">
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
        <span>Meter photo</span>
        {hasMeterPhoto ? (
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '3px',
              fontSize: '11px',
              fontWeight: 750,
              background: '#16a34a',
              color: '#ffffff',
              padding: '1.5px 7px',
              borderRadius: '999px',
              lineHeight: 1.2,
            }}
          >
            ✓ Uploaded
          </span>
        ) : (
          <span
            style={{
              fontSize: '11px',
              color: '#94a3b8',
              background: '#f1f5f9',
              padding: '1.5px 6px',
              borderRadius: '6px',
              fontWeight: 600,
            }}
          >
            Not uploaded
          </span>
        )}
      </button>
    </div>
  );
}
